import { fromJS } from 'immutable';
import { SET_TOP_BAR } from 'constants/ActionTypes';

const initialState = fromJS({
  title: null,
  tabs: null,
  extra: {},
});

const topBarReducer = (state = initialState, action) => {
  if (action.type === SET_TOP_BAR) {
    return state.merge(
      fromJS({
        title: action.title,
        tabs: action.tabs,
        extra: action.extra ? action.extra : {},
      }),
    );
  }
  return state;
};

export default topBarReducer;
